import {atom, useSetAtom} from "jotai";
import {useEffect} from "react";
import {useParams} from "react-router-dom";

/**
 * Atoms with React Router URL Path parameters
 */

export const routerCompanyIdAtom = atom<string | undefined>(undefined);

export const routerUserIdAtom = atom<string | undefined>(undefined);

export const routerFarmIdAtom = atom<string | undefined>(undefined);

export const routerFieldIdAtom = atom<string | undefined>(undefined);

export const routerOrderIdAtom = atom<string | undefined>(undefined);

export const useRouterParamsStoreSync = () => {
    const {companyId, farmId, fieldId, userId, orderId} = useParams();
    const setRouterCompanyId = useSetAtom(routerCompanyIdAtom);
    const setRouterFarmId = useSetAtom(routerFarmIdAtom);
    const setRouterFieldId = useSetAtom(routerFieldIdAtom);
    const setRouterUserId = useSetAtom(routerUserIdAtom);
    const setRouterOrderId = useSetAtom(routerOrderIdAtom);

    useEffect(() => {
        setRouterUserId(userId);
    }, [userId, setRouterUserId]);

    useEffect(() => {
        setRouterCompanyId(companyId);
    }, [companyId, setRouterCompanyId]);

    useEffect(() => {
        setRouterFarmId(farmId);
    }, [farmId, setRouterFarmId]);

    useEffect(() => {
        setRouterFieldId(fieldId);
    }, [fieldId, setRouterFieldId]);

    useEffect(() => {
        setRouterCompanyId(companyId);
        setRouterOrderId(orderId);
    }, [setRouterOrderId, setRouterCompanyId, companyId, orderId]);
};

routerFieldIdAtom.debugLabel = "activeRouterFieldAtom";
routerFarmIdAtom.debugLabel = "activeRouterFarmAtom";
